/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Text, VFlow } from 'bold-ui'
import { ParteBucalEnum } from 'graphql/types.generated'
import { Fragment, useState } from 'react'

import { Sextantes } from '../../odontograma/Sextantes'
import OdontogramaPopper from '../components/OdontogramaPopper'
import { convertSextantesFieldModelToSextantesModel } from '../converter'
import { getParteBucal } from '../util'
import { SextanteFieldModel } from './SextantesField'

interface SextanteActive {
  parteBucalEnum: ParteBucalEnum
  ref: HTMLButtonElement
  value: SextanteFieldModel
}

export interface SextantesViewProps {
  proteseTotalSuperior?: boolean
  proteseTotalInferior?: boolean
  value?: Record<ParteBucalEnum, SextanteFieldModel>
}

export default function SextantesView(props: SextantesViewProps) {
  const { proteseTotalSuperior, proteseTotalInferior, value } = props
  const [popperOpen, setPopperOpen] = useState(false)
  const [activeSextante, setActiveSextante] = useState<SextanteActive>()

  const onClick = (sextante: ParteBucalEnum, ref: HTMLButtonElement) => {
    setActiveSextante({ parteBucalEnum: sextante, ref, value: value && value[sextante] })
    setPopperOpen(true)
  }

  const handleClose = () => {
    setActiveSextante(undefined)
    setPopperOpen(false)
  }

  return (
    <Fragment>
      <div
        css={css`
          margin: -0.25rem 0;
        `}
      >
        <Sextantes
          onClick={onClick}
          activeItem={activeSextante?.parteBucalEnum}
          proteseTotalSuperior={proteseTotalSuperior}
          proteseTotalInferior={proteseTotalInferior}
          value={value && convertSextantesFieldModelToSextantesModel(value)}
        />
      </div>

      {activeSextante && (
        <OdontogramaPopper
          open={popperOpen}
          width={19.75}
          title={getParteBucal(activeSextante.parteBucalEnum).title}
          placement='top'
          anchorRef={activeSextante.ref}
          onClose={handleClose}
        >
          {!activeSextante.value?.procedimentos?.length ? (
            <Text>Nenhum procedimento registrado.</Text>
          ) : (
            <VFlow>
              {activeSextante.value.procedimentos?.length && (
                <VFlow vSpacing={0.5}>
                  <Text fontWeight='bold'>Procedimentos</Text>
                  <VFlow vSpacing={0}>
                    {activeSextante.value.procedimentos.map((procedimento, key) => (
                      <Text key={key}>{procedimento.descricao}</Text>
                    ))}
                  </VFlow>
                </VFlow>
              )}

              {!!activeSextante.value.observacoes?.filter((i) => !!i).length && (
                <VFlow vSpacing={0.5}>
                  <Text fontWeight='bold'>Observações</Text>

                  <VFlow vSpacing={0}>
                    {activeSextante.value.observacoes.map((observacao, key) => (
                      <Text key={key} dangerouslySetInnerHTML={{ __html: observacao }} />
                    ))}
                  </VFlow>
                </VFlow>
              )}
            </VFlow>
          )}
        </OdontogramaPopper>
      )}
    </Fragment>
  )
}
